<template>
    <div class="add-type-container">
        <common-top :commonTopData="commonTopData"></common-top>
        <div class="add_people_box">
            <p class="doc">{{people_id?'编辑':'添加'}}分类</p>
            <div class="input_box">
                <span class="title">新增分类名称</span>
                <el-input v-model="addTypeForm.title" maxlength="10"  placeholder="请输入分类名称" clearable></el-input>
            </div>
            <!-- 分类类型 -->
            <div class="input_box">
                <span class="title">分类类型</span>
                <el-select v-model="class_type.value" :disabled="people_id ? true : false" placeholder="请选择" @change="download_change(class_type)">
                    <el-option
                    v-for="item in class_type.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- 权重 -->
            <div class="input_box">
                <span class="title">权重</span>
                <el-input v-model="addTypeForm.weight" min="0" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请选择权重范围 (限数字)" clearable></el-input>
            </div>
            <!-- 权限范围 -->
            <div class="input_box" v-if="class_type.value=='2'">
                <span class="title">权限范围</span>
                <el-select v-model="limit_range.value" placeholder="请选择">
                    <el-option
                    v-for="item in limit_range.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- 所属父级节点 -->
            <div class="input_box" v-if="class_type.value=='1'">
                <span class="title">所属父级节点</span>
                <!-- <el-select v-model="addTypeForm.node" placeholder="请选择">
                    <el-option
                    v-for="item in checkbox_list"
                    :key="item.id"
                    :label="item.cate"
                    :value="item.id">
                    </el-option>
                </el-select> -->

                <el-cascader class="add-type-cascader" :options="checkbox_list" :props="{label:'cate', value:'id', children:'child', checkStrictly: true}" v-model="addTypeForm.node"></el-cascader>
            </div>
            <div class="input_box">
                <span class="title">上下架状态</span>
                <el-select v-model="stand_down.value" placeholder="请选择">
                    <el-option
                    v-for="item in stand_down.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="btn_container">
                <el-button @click="blck">返回</el-button>
                <el-button type="primary" @click="add">{{people_id?'确认':'添加'}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import commonTop from '@/components/commonTop.vue'

export default {
    components:{
        commonTop
    },
    data(){
        return{
            direction: 'rtl',
            class_type: {
                value:'2',
                options: [
                    { value: '2', label: '工程模板' },
                    { value: '1', label: '玩法插件' }
                ]
            },
            stand_down: {
                value:'1',
                options: [
                    { value: '1', label: '上架' },
                    { value: '-1', label: '下架' }
                ]
            },
            limit_range: {
                value:'0',
                options: [
                    { value: '0', label: '私有' },
                    { value: '1', label: '公共'}
                ]
            },
            addTypeForm: {
                title: '',
                weight: '',
                node: ''
            },
            checkbox_list:[],
            checkList: [],
            commonTopData: {
				"pageName": "newserviceCenter",
				"commonleftbtn": [],
				"commonrightbtn": [],
				"commonbottombtn":[],
			},
            table_obj:{},
            page:1,
            limit:10,
            user_list:[],
            tick_check_list:[],
            people_id:'',
            user_data:{},
            ceshi_list:[],
            add_user_list:[],
            // remark:'',//备注信息
        }    
    },
    mounted(){
        this.api.Lockscreen({
            type:1
        }).then((res) => {
            this.checkbox_list = res[0].child;
            if(this.$route.query.id){
                this.people_id = this.$route.query.id
                this.api.lockscreen_detailCat({id:this.people_id}).then(da =>{
                    this.addTypeForm.title = da.cate
                    this.addTypeForm.weight = da.sort_weight
                    this.addTypeForm.node = da.pid
                    this.class_type.value = da.type
                    this.stand_down.value = da.status

                    if(da.template_permissions){
                        try {
                            let prd = JSON.parse(da.template_permissions)
                            this.checkList = prd.map(e=>{
                                return [e]
                            })
                        } catch (error) {
                            this.checkList = []
                        }
                    }
                    this.encrypted_data.value = da.is_encrypt
                })
            }
        })
    },
    methods:{
        blck(){
            this.$router.push({path:'/new/set-lock-screen',query:{tabsnum:5}});
        },
        add(){
            if(!this.addTypeForm.title){
                this.$message.error('请输入新增分类名称')
                return
            }
            if(!this.addTypeForm.weight){
                this.$message.error('请选择权重范围')
                return
            }
            if (this.class_type.value == 1 && !this.addTypeForm.node) {
                this.$message.error('父节点不能为空')
                return
            }
   
            let data = {
                cate: this.addTypeForm.title,
                type: this.class_type.value, // 类型 1玩法插件 2工程模板
                sort_weight: this.addTypeForm.weight, // 权重
                is_visible: this.limit_range.value, // 权限范围
                status: this.stand_down.value, // 上下架
                pid: typeof this.addTypeForm.node =='string'? this.addTypeForm.node:this.addTypeForm.node[this.addTypeForm.node.length-1]
            }
            if (this.people_id) {
                data.id = this.people_id
            }

            this.api_name = this.people_id ? 'lockscreen_editCat':'lockscreen_addCat'

            this.api[this.api_name](data).then(res =>{
                this.$message({
                    type: 'success',
                    message: '操作成功'
                })
                this.$router.push({path:'/new/set-lock-screen',query:{tabsnum:5}});
			})
        },
        download_change (item) {
            if (item.value == 1) {
                this.addTypeForm.node = ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.add-type-container{
    width: 100%;
    height: calc(100% - 27px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow: auto;
    .add_people_box{
        background: #fff;
        margin: 20px 0;
        padding: 20px;
        .ul_container{
            display: flex;
            flex-wrap: wrap;
            li{
                position: relative;
                padding:10px 20px;
                margin: 20px;
                .el-image{
                    border-radius: 50%;
                    margin-right: 10px;
                }
                .del{
                    position: absolute;
                    right: 10px;
                    top: 10px;
                    cursor: pointer;
                    font-size: 20px;
                }
                p{
                    margin: 10px 0;
                }
                display: flex;
                flex-direction: column;
                width: 400px;
                border: 1px solid #ccc;
                .top_box{
                    display: flex;
                }
            }
        }
        .input_box{
            display: flex;
            align-items: center;
            margin: 20px 0;
            .title{
                width: 100px;
                display: flex;
                justify-content: flex-end;
                margin-right: 10px;
            }
            .el-input{
                width: 216px;
            }
            .el-textarea{
                width: 400px;
            }
            .checkbox-group-box{
                display: flex;
                flex-direction: column;
                border:1px solid #ccc;
                padding: 20px;
            }
        }
        .btn_container{
            display: flex;
            justify-content: center;
            padding: 30px 0;
            .el-button{
                width: 140px;
                height: 40px;
            }
        }
    }
    .pagination_box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 40px;
        .length_color{
            color: #33B3ff;
        }
    }
    .btn_box{
        display: flex;
        justify-content: center;
        padding: 20px 0;
    }
    .el-table{
        padding: 20px;
    }
    .dialog_box{
        .shaixuan{
            margin-left: 30px;
        }
    }
}
</style>

<style lang="scss">
.add-type-container{
    .checkbox_group_box{
        .el-checkbox__label{
            display: none !important;
        }
    }
    .el-dialog__body{
        display: flex;
        justify-content: center;
    }
    .drawer_box{
        padding: 20px;
        div{
            margin:10px 0;
        }
    }
}
.el-scrollbar__view {
    .el-radio {
        width: auto;  
    }
}
</style>
